/* global IMGIX_URI, IMGIX_TOKEN */
import Imgix from '../../shared/imgix'

// This instance works as-is for client side but not for the pre-render flow
// because webpacker will replace these values (via preact.config.js)
const imgix = new Imgix(IMGIX_URI, IMGIX_TOKEN)

export default imgix
